import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import LinkIcon from '@material-ui/icons/Link';

const styles = {
  button: {
    padding: '1px',
    pointerEvents: 'none'
  },
  redirectButton: {
    padding: '1px'
  },
  iconColor: {
    color: 'green'
  }
};

const enhance = compose();

const button = enhance(
  ({
    classes,
    id = null,
    onClickAction = null,
    btnText = '',
    disabled = false
  }) => {
    return (
      <Button
        className={id ? classes.redirectButton : classes.button}
        tabIndex={id ? '0' : '-1'}
        onClick={() => onClickAction(id)}
        disabled={disabled}
        color="primary"
      >
        <LinkIcon />
        {btnText}
      </Button>
    );
  }
);

export default withRouter(withStyles(styles)(button));
